import { render } from "./ReviewPeriodCell.vue?vue&type=template&id=74304008&scoped=true"
import script from "./ReviewPeriodCell.vue?vue&type=script&lang=js"
export * from "./ReviewPeriodCell.vue?vue&type=script&lang=js"

import "./ReviewPeriodCell.vue?vue&type=style&index=0&id=74304008&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74304008"]])

export default __exports__